import { Job } from "types/Job";

const jobData: Job[] = [
	{
		type: 'Part-time',
		title: "Software Engineer",
		company: "Montel",
		summary: ["Working in the frontend team in the latest project to create a marketplace for Montel customer. Learn to create scalable, flexible, and effective solutions.", "Limit use of external libraries in the project and develop custom components with flexibles and reusable functionality.", "Tech: react (ts, scss, HOC, context and more)"],
		hashtags: ["#Frontend", "#react", "#typescript", "#.net", "#azure-devops", "#figma", "#restapi ","#swagger"],
		logo: 'images/experience/montel_logo.jpeg',
	},
	{
		type: 'Part-time',
		title: "Software Engineer",
		company: "Dops",
		summary:["Learned to be independent cautious and how to work with others in project.",
		"Working with and create domain-based projects and internal/external webservices using Angular and .NET frameworks."],
		hashtags:  ["#angular",
				"#typescript",
				"#.net-core",
				"#ASP.NET-MVC",
				"#azure-devops",
				"#bootstrap",
				"#microsoft-sql-server",
				"#entity-framework-core",]
	},
	{
		type: 'Internship',
		title: "Software Engineer",
		company: "Cognite",
		summary: ["Work as a frontend engineer in a product called Charts.",
		"Charts is a powerful tool for engineers and domain experts to explore, trend, and analyze industrial data. It gives industrial experts instant access to data and no-code tools to find, understand and troubleshoot for actionable insights."],
		hashtags: ["#Frontend", "#react", "#typescript", "#firebase", "#jira", "#scrum", "#figma", "#restapi","#asana"],
		logo: 'images/experience/cognite_logo.jpeg',
	},
	{
		type: 'Internship',
		title: "Software Engineer",
		company: "Visma Consulting",
		summary: ["Frontend lead (React.js)",
		"Managed a frontend team of 3 in an internal project at Visma. ",
		"Learned to analyze, prioritize and define tasks for each sprint. Helps others with any technical related to their task and lastly provided skills and knowledge with the development itself."],
		hashtags: ["#Frontend", "#react", "#javascript", "#.net", "#azure-devops", "#scrum", "#figma", "#restapi ","#postman"],
		logo: 'images/experience/visma_logo.png',
	},
];

export default jobData;